import React from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles'
import Button from '@material-ui/core/Button';
import * as actions from '../../store/actions/index';
import axios from 'axios';
import PropTypes from 'prop-types';
import './App.css';
import Iframe from 'react-iframe';
var httpBuildQuery = require('http-build-query');
var sha512 = require('js-sha512');
var moment = require('moment');

class PaymentAsia extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            uniqueId: localStorage.getItem('token'),
            username: this.props.clientName,
            clientIP:'',
            value: '',
            firstname:'',
            lastname:'',
            phone:'',
            email:''
        };
   
    }

    componentDidMount() {
        let url = `${process.env.REACT_APP_SERVER_HOSTNAME}:${process.env.REACT_APP_SERVER_PORT}/getIP`;
        var payload={};

        axios.post(url, payload)
        .then((response) => {
            console.log('IP: '+JSON.stringify(response));
             
            this.setState({
                clientIP:response.data.IP
            })

        })
        .catch((error) => {
            console.log(error);
        });

        let uniqueId = localStorage.getItem('token');
        let userType = '';
        if(this.props.caseData.claimantUniqueId == uniqueId){
            userType = 'claimant';
        }else if(this.props.caseData.respondentUniqueId == uniqueId){
            userType = 'respondent';
        }

        if (this.props.caseData.agreement_type == 'EstateAgentDispute'){

            if (this.props.caseData.a1 == 'sole'){
                if (this.props.caseData.a2 == 'vendor'){

                   
                    if (userType == 'claimant'){
                        var name = (''+this.props.caseData.a3).split(' ');
                        this.setState({
                            firstname:this.props.caseData.a3,
                            lastname:name[0],
                            phone:this.props.caseData.a3c,
                            email:this.props.caseData.a3b
                        })
                    }
                    else if (userType == 'respondent'){
                        var name2 = (''+this.props.caseData.namesOfVendors[0].a4).split(' ');
                        this.setState({
                            firstname:this.props.caseData.namesOfVendors[0].a4,
                            lastname:name2[0],
                            phone:this.props.caseData.namesOfVendors[0].a11b,
                            email:this.props.caseData.namesOfVendors[0].a11a
                        })
                    }

                    
                }
                else if (this.props.caseData.a2 == 'purchaser'){

                    if (userType == 'claimant'){
                        var name3 = (''+this.props.caseData.a3).split(' ');
                        this.setState({
                            firstname:this.props.caseData.a3,
                            lastname:name3[0],
                            phone:this.props.caseData.a3c,
                            email:this.props.caseData.a3b
                        })
                    }
                    else if (userType == 'respondent'){
                        var name4 = (''+this.props.caseData.namesOfPurchasers[0].a12a).split(' ');
                        this.setState({
                            firstname:this.props.caseData.namesOfPurchasers[0].a12a,
                            lastname:name4[0],
                            phone:this.props.caseData.namesOfPurchasers[0].a12j,
                            email:this.props.caseData.namesOfPurchasers[0].a12i
                        })
                    }

                    
                }
            }
            else if (this.props.caseData.a1 == 'seperate'){

                if (userType == 'claimant'){
                    var name5 = (''+this.props.caseData.a3).split(' ');
                        this.setState({
                            firstname:this.props.caseData.a3,
                            lastname:name5[0],
                            phone:this.props.caseData.a3c,
                            email:this.props.caseData.a3b
                        })
                }
                else if (userType == 'respondent'){
                    var name6 = (''+this.props.caseData.namesOfA2[0].a4).split(' ');
                        this.setState({
                            firstname:this.props.caseData.namesOfA2[0].a4,
                            lastname:name6[0],
                            phone:this.props.caseData.namesOfA2[0].a11b,
                            email:this.props.caseData.namesOfA2[0].a11a
                        })
                }
                
            }
        
        }
        else if (this.props.caseData.agreement_type == 'MoneyLent'){
            if (userType == 'claimant'){
                var name7 = (''+this.props.claimant_name).split(' ');
                this.setState({
                    firstname:this.props.claimant_name,
                    lastname:name7[0],
                    phone:this.props.claimant_telephone,
                    email:this.props.claimant_email_address
                })
                
            }
            else if (userType == 'respondent'){

                var name8 = (''+this.props.respondent_name).split(' ');
                this.setState({
                    firstname:this.props.respondent_name,
                    lastname:name8[0],
                    phone:this.props.respondent_telephone,
                    email:this.props.respondent_email_address
                });

            }

            
        }
        else if (this.props.caseData.agreement_type == 'SalesOfGoods'){
            if (userType == 'claimant'){
                var name = (''+this.props.caseData.a1).split(' ');
                this.setState({
                    firstname:this.props.caseData.a1,
                    lastname:name[0],
                    phone:this.props.caseData.a8c,
                    email:this.props.caseData.a8b
                })
            }
            else if (userType == 'respondent'){
                var name2 = (''+this.props.caseData.a9).split(' ');
                this.setState({
                    firstname:this.props.caseData.a9,
                    lastname:name2[0],
                    phone:this.props.caseData.a16b,
                    email:this.props.caseData.a16a
                })
            }
        }
        else if (this.props.caseData.agreement_type == 'serviceDispute'){
            if (userType == 'claimant'){
                var name = (''+this.props.caseData.a1).split(' ');
                this.setState({
                    firstname:this.props.caseData.a1,
                    lastname:name[0],
                    phone:this.props.caseData.a8c,
                    email:this.props.caseData.a8b
                })
            }
            else if (userType == 'respondent'){
                var name2 = (''+this.props.caseData.a9).split(' ');
                this.setState({
                    firstname:this.props.caseData.a9,
                    lastname:name2[0],
                    phone:this.props.caseData.a16b,
                    email:this.props.caseData.a16a
                })
            }
        }
        else if (this.props.caseData.agreement_type == 'insuranceDispute'){
            if (userType == 'claimant'){
                var name = (''+this.props.caseData.a1).split(' ');
                this.setState({
                    firstname:this.props.caseData.a1,
                    lastname:name[0],
                    phone:this.props.caseData.a8c,
                    email:this.props.caseData.a8b
                })
            }
            else if (userType == 'respondent'){
                var name2 = (''+this.props.caseData.a9).split(' ');
                this.setState({
                    firstname:this.props.caseData.a9,
                    lastname:name2[0],
                    phone:this.props.caseData.a16b,
                    email:this.props.caseData.a16a
                })
            }
        }

        if (this.props.caseData.a1 == 'sole'){
            if (this.props.caseData.a2 === 'vendor'){
                
                this.setState({
                    value: parseInt(this.props.caseData.a15f)
                })
            }
            else if (this.props.caseData.a2 === 'purchaser'){
                
                this.setState({
                    value: parseInt(this.props.caseData.a16f)
                })
            }
        }
        else if (this.props.caseData.a1 == 'seperate'){
            this.setState({
                value: parseInt(this.props.caseData.a16f)
            })
        }


    }

    componentDidUpdate() {
        
    }

    makeid(length) {
        var result           = '';
        var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        var charactersLength = characters.length;
        for ( var i = 0; i < length; i++ ) {
          result += characters.charAt(Math.floor(Math.random() * 
     charactersLength));
       }
       return result;
    }

    submitHandler = (event) => {
        
        event.preventDefault();
            var timestamp = new Date();
            let uniqueId = localStorage.getItem('token');
            let userType = '';
            if(this.props.caseData.claimantUniqueId == uniqueId){
                userType = 'claimant';
            }else if(this.props.caseData.respondentUniqueId == uniqueId){
                userType = 'respondent';
            }
            var time = timestamp.getFullYear()+''+timestamp.getMonth()+''+timestamp.getDate()+''+timestamp.getHours()+''+timestamp.getMinutes()+''+timestamp.getSeconds()
            var rxd = this.makeid(5)
            console.log('rxd: '+rxd)
            var payload = {
                merchant_reference: this.props.caseId+'_'+userType+'_'+rxd,
                currency:'HKD',
                amount:this.props.total,
                customer_ip:this.state.clientIP,
                customer_first_name:this.state.firstname,
                customer_last_name:this.state.lastname,
                customer_phone:this.state.phone,
                customer_email:this.state.email,
                customer_country:'CN',
                customer_state:'HK',
                network:'Alipay',
                return_url:'https://www.hkemc.com.hk/hkemc.php'
            }

            // var load = httpBuildQuery(payload); 

            // var sign = sha512(load);

            // payload.sign = sign;

            console.log('Payment Asia payload: '+JSON.stringify(payload))
            //changed
            var url = 'https://www.hkarbsoc.org.hk/paymentasia.html'
            var newWindow = window.open(url);
            newWindow.pd = payload;
            this.checkPaymentStatus(1)
            // axios.post('https://www.hkarbsoc.org.hk/gen-sign.php', load,{ 
            //     headers: {
            //     'Access-Control-Allow-Origin': '*'
            //   }})
            // .then((response) => {
                
            //     console.log('PaymentAsia AliPay Response: '+JSON.stringify(response));
            // })
            // .catch((error) => {
            //     console.log('PaymentAsia AliPay Response: '+error);
            // });
    };

    async checkPaymentStatus(trial=1){
        if (trial < 60){
            setTimeout(()=>{
                this.checkIfPaymentSuccessful(trial+1);
            },2000)
        }
    }

    checkIfPaymentSuccessful(trial){
        let url = `${process.env.REACT_APP_SERVER_HOSTNAME}:${process.env.REACT_APP_SERVER_PORT}/checkIfPaymentPaid`;
        let uniqueId = localStorage.getItem('token');
        let userType = '';
        if(this.props.caseData.claimantUniqueId == uniqueId){
            userType = 'claimant';
        }else if(this.props.caseData.respondentUniqueId == uniqueId){
            userType = 'respondent';
        }
        let payload = {
            caseId: this.props.caseId,
            userType: userType
        }
        axios.post(url, payload)
        .then((response) => {
            console.log('checkIfPaymentSuccessful: '+JSON.stringify(response.data))
            if (response.data){
                window.location.reload()
            }
            else{
                this.checkIfPaymentSuccessful(trial)
            }
        })
        .catch((error) => {
            this.checkIfPaymentSuccessful(trial)
        });
    }
   
    handleChange(event) { 
        this.setState({value: event.target.value});
        console.log('handleChange: '+this.state.value)
      }

    render() {
        let file = __dirname + 'paymentasia.html'
        return ( 
            <div >
            <form onSubmit={this.submitHandler} >
                <Button
                    variant="contained"
                    type="submit"
                    color="primary"
                    disabled={this.state.loginInProgress}
                    //className={classes.button}
                    //onClick={this.performLogin}
                >
                    {this.context.t('WeChat Pay / AliPay')}
                </Button>

                    {/* <Iframe url={file}
                    width="90%"
                    height="800px"
                    id="myId"
                    className="myClassname"
                    // display="initial"
                    position="relative"
                    allowFullScreen
                    styles={{margin: '0 auto',overflow:'scroll'}}
                /> */}



                    </form>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        caseId: state.caseInfo.caseId,
        claimantUniqueId: state.caseInfo.claimantUniqueId,
        respondentUniqueId: state.caseInfo.respondentUniqueId,
        claimant_name: state.caseInfo.claimant_name,
        respondent_name: state.caseInfo.respondent_name,
        userType: state.caseInfo.userType,
        clientName: state.caseInfo[`${state.caseInfo.userType}_name`],
        caseData: state.caseInfo.caseData,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
            // getCaseInfo: (caseId) => dispatch(actions.getCaseInfo(caseId)),
    }
}

PaymentAsia.contextTypes = {
    t: PropTypes.func
}

export default (connect(mapStateToProps, mapDispatchToProps)(PaymentAsia));